<app-apply-shell
    previousRoute="/tourist-permit"
    previousLabel="Tourist Permit"
    permitLabel="Tourist Permit"
    [showForm]="!result"
    outcome="A Tourist Permit is issued for a maximum of 3 days to enter a community for tourism purposes (e.g. visiting an art centre or museum, watching a footy match). Most Tourist Permits are issued automatically."
>
    @if (!result) {
        <app-closure-notice></app-closure-notice>
        <ngxh6-form-embed
            [formName]="'tourist_pass'"
            [options]="{ sticky_actions: false, reload_on_save: false, show_delete: false, show_archive: false }"
            (submitted)="onSubmitted($event)"
        ></ngxh6-form-embed>
    } @else if (result.status === 'active') {
        <app-permit-result state="issued" [email]="result.email" [partySize]="result.partySize" [body]="result.submitMessage">
            <a class="btn btn-primary ms-0" [routerLink]="['/permit', result.token]">View my permit</a>
            <a class="btn btn-outline-secondary ms-0" [href]="pdfUrl" target="_blank" rel="noopener">
                <i class="fa fa-file-pdf me-2" aria-hidden="true"></i>Download PDF
            </a>
            <!-- The tourist locations map, shown only when TLC have published one (mapUrl is
                 null otherwise). The same map is also attached to the issued permit email. -->
            @if (mapUrl) {
                <a class="btn btn-outline-secondary ms-0" [href]="mapUrl" target="_blank" rel="noopener">
                    <i class="fa fa-map-location-dot me-2" aria-hidden="true"></i>Download map
                </a>
            }
        </app-permit-result>
    } @else {
        <app-permit-result state="pending" [email]="result.email" [partySize]="result.partySize" [body]="result.submitMessage">
            <a class="btn btn-primary ms-0" [routerLink]="['/permit', result.token]">Check application status</a>
        </app-permit-result>
    }
</app-apply-shell>
